import { Components, Theme } from '@mui/material/styles';
import scssVariables from '@styles/variables.module.scss';

export const MuiPaper: Components<Theme>['MuiPaper'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      backgroundImage: 'none',
      backgroundColor: scssVariables.ColorBlack10,
      border: `0.5px solid ${scssVariables.ColorFog20}`,

      "[data-popper-placement='top'] &": {
        transform: 'translateY(-4px)',
      },
      "[data-popper-placement='bottom'] &": {
        transform: 'translateY(2px)',
      },

      ...theme.applyStyles('dark', {
        backgroundColor: scssVariables.ColorBlack100,
        borderColor: scssVariables.ColorBlack60,
      }),
    }),
  },

  variants: [
    {
      props: { padded: true },
      style: {
        padding: 'var(--spacing-unit-2)',
      },
    },
  ],
};
